import(/* webpackMode: "eager" */ "/var/www/apporb-web/frontend/src/app/accounts/new/page.tsx");
